export const getExams = state => state.entities.exams
export default getExams
